import { render } from "./TheFooter.vue?vue&type=template&id=76f7d811"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\eurolimo-drivers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__